import logo from '@assets/images/logo.png';
import Box from '@mui/material/Box';
import type { SxProps, Theme } from '@mui/material/styles';

interface BrandLogoProps {
  alt?: string;
  height?: number;
  onClick?: () => void;
  sx?: SxProps<Theme>;
}

const lightMarkFilter = 'invert(1) hue-rotate(180deg)';

export const BrandLogo = ({
  alt = 'r8tr',
  height = 40,
  onClick,
  sx,
}: BrandLogoProps): JSX.Element => (
  <Box
    component="img"
    src={logo}
    alt={alt}
    onClick={onClick}
    sx={[
      {
        display: 'block',
        height,
        width: 'fit-content',
        maxWidth: '100%',
        alignSelf: 'flex-start',
        objectFit: 'contain',
        cursor: onClick ? 'pointer' : 'default',
        filter: (theme) =>
          theme.palette.mode === 'light' ? lightMarkFilter : 'none',
      },
      ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
    ]}
  />
);
